export default () => ({
	locale: "cs",
	legacy: false,
	globalInjection: true,
	pluralRules: { 
	// The translation string can have a special case for zero
	// without zero: 1 | 2, 3, 4 | 5, ...
	// with zero: 0 | 1 | 2, 3, 4 | 5, ...
cs(choice, choicesLength) {
		const hasSpecialZero = choicesLength === 4;
		if (hasSpecialZero && choice === 0) {
			return 0;
		}
		let result = 0;
		if (choice >= 5 || choice === 0) {
			result = 2;
		} else if (choice >= 2) {
			result = 1;
		}
		return hasSpecialZero ? result + 1 : result;
	} },
	numberFormats: { cs: {
		currency: {
			style: "currency",
			currencyDisplay: "symbol",
			currency: "CZK",
			maximumFractionDigits: 0
		},
		currencyWithPennies: {
			style: "currency",
			currencyDisplay: "symbol",
			currency: "CZK",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		},
		decimalWithPennies: {
			style: "decimal",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}
	} }
});
